module.exports = __webpack_public_path__ + "static/media/info-filled.b39ea7bb.svg";